// @view/workspace/FeedbackSuccessModalHidden.view.tsx

import React from "react";
import type { FeedbackSubmissionViewProps } from "@ps-bridge/contracts/feedbackSubmission";
import EmptyView from "@view/EmptyView";

type FeedbackSuccessModalHiddenContractProps = Pick<FeedbackSubmissionViewProps, never>;

const FeedbackSuccessModalHiddenView: React.FC<FeedbackSuccessModalHiddenContractProps> = () => {
  return <EmptyView />;
};

export default FeedbackSuccessModalHiddenView;
